import React, { useEffect, useState } from "react";
import AppShell from "@/components/AppShell";
import { api } from "@/lib/config";
import { Button } from "@/components/ui/button";
import { CalendarDays, Video, ExternalLink, PlayCircle } from "lucide-react";

export default function Events() {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/events").then((r) => setEvents(r.data)).catch(() => {}); }, []);

  const upcoming = events.filter((e) => !e.is_replay);
  const replays = events.filter((e) => e.is_replay);

  return (
    <AppShell>
      <div className="space-y-10">
        <div>
          <div className="text-[11px] tracking-[0.25em] uppercase text-[#FF8A00]">Live Events</div>
          <h1 className="font-display text-4xl sm:text-5xl mt-2">Show up. Ask anything.</h1>
          <p className="text-white/55 mt-2">Monthly Q&A with Dr. Slava + your growing replay library.</p>
        </div>

        <section>
          <h2 className="font-display text-2xl mb-4">Upcoming</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {upcoming.map((e) => (
              <div key={e.event_id} data-testid={`event-${e.event_id}`}
                className="glass rounded-2xl p-6 flex flex-col">
                <div className="flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-[#FF8A00]">
                  <CalendarDays size={14} /> {formatDate(e.starts_at)}
                </div>
                <h3 className="font-display text-2xl mt-3">{e.title}</h3>
                <p className="text-sm text-white/55 mt-2 flex-1">{e.description}</p>
                <Button onClick={() => window.open(e.zoom_url, "_blank")}
                  data-testid={`join-event-${e.event_id}`}
                  className="mt-4 self-start rounded-full bg-gradient-to-r from-[#FF8A00] to-[#E52E71]">
                  <Video size={14} className="mr-2" /> Join Zoom <ExternalLink size={12} className="ml-2" />
                </Button>
              </div>
            ))}
            {upcoming.length === 0 && <p className="text-white/40 text-sm">No upcoming events scheduled.</p>}
          </div>
        </section>

        <section>
          <h2 className="font-display text-2xl mb-4">Replay Library</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {replays.map((e) => (
              <a key={e.event_id} href={e.zoom_url} target="_blank" rel="noreferrer"
                 data-testid={`replay-${e.event_id}`}
                 className="group rounded-2xl overflow-hidden bg-[#0A0A0A] border border-white/5 hover:border-[#FF8A00]/30 transition-all">
                <div className="aspect-video bg-gradient-to-br from-[#FF8A00]/20 to-[#E52E71]/10 flex items-center justify-center">
                  <PlayCircle size={42} className="text-white/70 group-hover:text-[#FF8A00] transition-colors" />
                </div>
                <div className="p-5">
                  <div className="text-[11px] text-white/40">{formatDate(e.starts_at)}</div>
                  <div className="font-display text-lg mt-1">{e.title}</div>
                </div>
              </a>
            ))}
            {replays.length === 0 && <p className="text-white/40 text-sm">No replays yet.</p>}
          </div>
        </section>
      </div>
    </AppShell>
  );
}

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleString(undefined, { month: "long", day: "numeric", hour: "numeric", minute: "2-digit" });
  } catch { return ""; }
}
